/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogTime } from "../../d-dialog-time";
import { DThemeDarkDialogFitted } from "./d-theme-dark-dialog-fitted";

export class DThemeDarkDialogTime extends DThemeDarkDialogFitted implements DThemeDialogTime {}
